// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import {
//   MapPin,
//   DollarSign,
//   Bed,
//   Bath,
//   Maximize,
//   Edit,
//   Trash2,
//   User,
//   Eye
// } from "lucide-react";

// import "../../css/properties/propertycard.css";
// import { useNavigate } from "react-router-dom";
// import api from "../../api/api";

// // const statusColors = {
// //   available: "status-available",
// //   under_offer: "status-under-offer",
// //   sold: "status-sold",
// //   rented: "status-rented",
// // };

// export default function PropertyCard({ property, index, onEdit , onDelete, isAdmin,onStatusChange}) {
// //  const mainImage =
// //   property.images && property.images.length > 0
// //     ? `https://apicrm.zenrealty.com${property.images[0]}`
// //     : "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800";

// //     console.log("IMAGE URL:", `https://apicrm.zenrealty.com${property.images[0]}`);


// const API_BASE = "https://apicrm.zenrealestate.in";

// const [properties, setProperties] = useState();
// const [otherReason, setOtherReason] = useState(
//   property.propertyOtherReason || ""
// );

// const PROPERTY_STATUSES = [
//   "available",
//   "under_offer",
//   "sold",
//   "rented",
//   "unavailable",
//   "under_construction",
//   "other"
// ];

// const statusColors = {
//   available: "status-available",
//   under_offer: "status-under-offer",
//   sold: "status-sold",
//   rented: "status-rented",
//   unavailable: "status-unavailable",
//   under_construction: "status-construction",
//   other: "status-other"
// };


// const handleStatusChange = (e) => {
//   const newStatus = e.target.value;

//   // clear reason if not other
//   if (newStatus !== "other") {
//     setOtherReason("");
//     onStatusChange(property._id, newStatus, "");
//   } else {
//     onStatusChange(property._id, newStatus, otherReason);
//   }
// };





// const navigate = useNavigate()

// const mainImage =
//   property.images?.length > 0
//     ? `${API_BASE}/${property.images[0]}`
//     : "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800";


// console.log("IMAGE URL:", mainImage);


//   return (
//     <motion.div
//       className="property-card-wrapper"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ delay: index * 0.05 }}
//     >
//       <div className="property-card">
//         {/* IMAGE */}
//         <div className="property-image">
//           <img src={mainImage} alt={property.propertyName} />



//           <span className="listing-badge">
//             {property.listingType === "sale" ? "For Sale" : "For Rent"}
//           </span>
//         </div>

//         {/* HEADER */}
//         <div className="property-header">
//           <div>
//             <h3>{property.propertyName}</h3>
//             <div className="location">
//               <MapPin size={14} />
//               <span>{property.location}</span>
//             </div>
//           </div>

// <button
//       className="icon-btn"
//       onClick={() => navigate(`/properties/${property._id}`)}
//     >
//       <Eye size={16} />
//     </button>

//          {isAdmin && (
//   <>
//     <button className="icon-btn" onClick={onEdit}>
//       <Edit size={16} />
//     </button>

//     {/* <button className="icon-btn" onClick={onDelete}>
//       <Trash2 size={16} />
//     </button> */}
//   </> 
//          )}

//           {/* <button className="icon-btn" onClick={onDelete}>
//             <Trash2 size={16} />
//           </button> */}
//         </div>

//         {/* CONTENT */}
//         <div className="property-content">
//           <div className="price">
//             {/* <DollarSign size={18} /> */}
//             <strong>₹{property.price}</strong>
//             {property.listingType === "rent" && <span>/month</span>}
//           </div>

//           <div className="features">
//             {property.bedrooms && (
//               <span>
//                 <Bed size={14} /> {property.bedrooms} Beds
//               </span>
//             )}
//             {property.washrooms && (
//               <span>
//                 <Bath size={14} /> {property.washrooms} Baths
//               </span>
//             )}
//             {property.area && (
//               <span>
//                 <Maximize size={14} /> {property.area}{property.areaunit}
//               </span>
//             )}

         

//   </div>


//           <div className="property-type">
//             {property.propertyType}
//           </div>

          
//           {isAdmin ? (
//   <select
//     className={`status-dropdown ${statusColors[property.status]}`}
//     value={property.status}
//     onChange={handleStatusChange}
//   >
//     {PROPERTY_STATUSES.map((status) => (
//       <option key={status} value={status}>
//         {status.replace("_", " ")}
//       </option>
//     ))}
//   </select>
// ) : (
//   <span className={`status-pills ${statusColors[property.status]}`}>
//     {property.status.replace("_", " ")}
//   </span>
// )}



// {property.status === "other" && property.propertyOtherReason && (
//   <div className="status-reason">
//     <strong>Reason:</strong> {property.propertyOtherReason}
//   </div>
// )}


//           {isAdmin && property.createdByEmail && (
//   <div className="info-row created-by border-top">
//     <User size={14} />
//     <span>
//       Created by: <strong>{property.createdByEmail}</strong>
//     </span>
//   </div>
// )}

//           {property.description && (
//             <p className="description">{property.description}</p>
//           )}
//         </div>
//       </div>
//     </motion.div>
//   );
// }


// Updated: 02-04-2026
// Changes:
// - Edit & status change restricted to property creator (or admin)
// - Commercial / Residential category tag displayed on card
// - Price displayed in formatted INR (Lakhs/Crores) using helper

// Updated: 02-04-2026
// Changes:
// - Fixed image URL: stored paths start with "/" so joining with API_BASE
//   produced double-slash (https://apicrm.zenrealestate.in//uploads/...). Now strips
//   the leading slash before concatenation.
// - Shows "Amount / Hour" on card when listing type is rent and value exists

import React, { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Bed, Bath, Maximize, Edit, User, Eye, Building2, Home, Clock } from "lucide-react";
import "../../css/properties/propertycard.css";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://apicrm.zenrealestate.in";

/* ─── Fix double-slash: "/uploads/x.jpg" → "https://apicrm.zenrealestate.in/uploads/x.jpg" ─── */
function buildImageUrl(imgPath) {
  if (!imgPath) return null;
  // If it's already an absolute URL (http/https), use it directly
  if (imgPath.startsWith("http")) return imgPath;
  // Strip any leading slash so we don't end up with double-slash
  return `${API_BASE}/${imgPath.replace(/^\/+/, "")}`;
}

// Clean architectural placeholder for properties without images
const FALLBACK_IMAGE = "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&q=80";

const PROPERTY_STATUSES = [
  "available",
  "under_offer",
  "sold",
  "rented",
  "unavailable",
  "under_construction",
  "other",
];

const statusColors = {
  available:          "status-available",
  under_offer:        "status-under-offer",
  sold:               "status-sold",
  rented:             "status-rented",
  unavailable:        "status-unavailable",
  under_construction: "status-construction",
  other:              "status-other",
};

function formatINR(value) {
  const num = parseFloat(String(value).replace(/[^0-9.]/g, ""));
  if (isNaN(num) || num === 0) return value;
  if (num >= 10_000_000) return `₹${(num / 10_000_000).toFixed(2).replace(/\.?0+$/, "")} Cr`;
  if (num >= 100_000)    return `₹${(num / 100_000).toFixed(2).replace(/\.?0+$/, "")} L`;
  if (num >= 1_000)      return `₹${(num / 1_000).toFixed(2).replace(/\.?0+$/, "")} K`;
  return `₹${num}`;
}

function getCategoryTag(property) {
  if (property.propertyCategory) {
    return property.propertyCategory === "commercial" ? "Commercial" : "Residential";
  }
  const commercialTypes = ["office_space", "commercial_shop", "showroom", "sco", "dss", "commercial_plot"];
  const type = (property.propertyType || "").toLowerCase();
  return commercialTypes.some((t) => type.includes(t)) ? "Commercial" : "Residential";
}

export default function PropertyCard({
  property,
  index,
  onEdit,
  onDelete,
  isAdmin,
  onStatusChange,
}) {
  const [otherReason, setOtherReason] = useState(property.propertyOtherReason || "");
  const navigate = useNavigate();

  /* ── Fixed image URL ── */
  const mainImage =
    property.images?.length > 0
      ? buildImageUrl(property.images[0])
      : FALLBACK_IMAGE;

  // Only admins can edit or change status
  const canEdit = isAdmin;

  const isRent = property.listingType === "rent";

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    if (newStatus !== "other") {
      setOtherReason("");
      onStatusChange(property._id, newStatus, "");
    } else {
      onStatusChange(property._id, newStatus, otherReason);
    }
  };

  const categoryLabel = getCategoryTag(property);
  const categoryIcon  = categoryLabel === "Commercial" ? <Building2 size={11} /> : <Home size={11} />;

  return (
    <motion.div
      className="property-card-wrapper"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
    >
      <div className="property-card">

        {/* IMAGE */}
        <div className="property-image">
          <img
            src={mainImage}
            alt={property.propertyName}
            onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
          />
          <span className="listing-badge">
            {isRent ? "For Rent" : "For Sale"}
          </span>
          <span className={`category-badge ${categoryLabel === "Commercial" ? "badge-commercial" : "badge-residential"}`}>
            {categoryIcon} {categoryLabel}
          </span>
        </div>

        {/* HEADER */}
        <div className="property-header">
          <div>
            <h3>{property.propertyName}</h3>
            <div className="location">
              <MapPin size={14} />
              <span>{property.location}</span>
            </div>
          </div>

          <button className="icon-btn" onClick={() => navigate(`/properties/${property._id}`)}>
            <Eye size={16} />
          </button>

          {canEdit && (
            <button className="icon-btn" onClick={onEdit}>
              <Edit size={16} />
            </button>
          )}
        </div>

        {/* CONTENT */}
        <div className="property-content">

          {/* Price */}
          <div className="price">
            <strong>{formatINR(property.price)}</strong>
            {isRent && <span>/month</span>}
          </div>

          <div className="features">
            {property.bedrooms  && <span><Bed size={14} /> {property.bedrooms} Beds</span>}
            {property.washrooms && <span><Bath size={14} /> {property.washrooms} Baths</span>}
            {property.area      && <span><Maximize size={14} /> {property.area} {property.areaunit}</span>}
          </div>

          <div className="property-type">{property.propertyType}</div>

          {/* Status control */}
          {canEdit ? (
            <select
              className={`status-dropdown ${statusColors[property.status] || ""}`}
              value={property.status}
              onChange={handleStatusChange}
            >
              {PROPERTY_STATUSES.map((s) => (
                <option key={s} value={s}>{s.replace(/_/g, " ")}</option>
              ))}
            </select>
          ) : (
            <span className={`status-pills ${statusColors[property.status] || ""}`}>
              {property.status?.replace(/_/g, " ")}
            </span>
          )}

          {property.status === "other" && property.propertyOtherReason && (
            <div className="status-reason">
              <strong>Reason:</strong> {property.propertyOtherReason}
            </div>
          )}

          {property.createdByEmail && (
            <div className="info-row created-by border-top">
              <User size={14} />
              <span>Created by: <strong>{property.createdByEmail}</strong></span>
            </div>
          )}
 
          {property.description && (
            <p className="description">{property.description}</p>
          )}
        </div>

      </div>
    </motion.div>
  );
}